export default "__VITE_ASSET__E0XjiXYM__"